import script from "./CompactPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./CompactPlayer.vue?vue&type=script&setup=true&lang=js"

import "./CompactPlayer.vue?vue&type=style&index=0&id=55f3d68a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55f3d68a"]])

export default __exports__